module.exports = __webpack_public_path__ + "media/bom/not-found-5f267125.png";